import { render, staticRenderFns } from "./DataSyncFailLogs.vue?vue&type=template&id=42ed03b9&scoped=true"
import script from "./DataSyncFailLogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSyncFailLogs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataSyncFailLogs.vue?vue&type=style&index=0&id=42ed03b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed03b9",
  null
  
)

export default component.exports